import React, { useState } from "react";
import { ImageList, ImageListItem } from "@mui/material"; // Adjust imports based on your library
import { useSwipeable } from "react-swipeable";
import ImageViewer from "./ImageViewer";

interface Document {
  name: string;
  url: string;
}
interface GalleryProps {
  images: Document[];
}

const Gallery: React.FC<GalleryProps> = ({ images }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isViewerImageOpen, setViewerImage] = useState(false);

  const openViewerImage = () => {
    setViewerImage(true);
  };

  const openDrawer = (index: number) => {
    setCurrentIndex(index);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const showPreviousImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images?.length - 1 : prevIndex - 1
    );
  };

  const showNextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images?.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => showNextImage(),
    onSwipedRight: () => showPreviousImage(),
    trackMouse: true,
  });

  return (
    <div className="">
      <ImageList variant="masonry" cols={3} gap={16}>
        {images?.length > 0 &&
          images.map((image, index) => (
            <ImageListItem
              key={image.name}
              onClick={() => openDrawer(index)}
              className="cursor-pointer hover:shadow-2xl shadow-md"
            >
              <img
                src={image.url}
                srcSet={`${image.url}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                alt={image.name}
                loading="lazy"
                onClick={() => openViewerImage()}
              />
            </ImageListItem>
          ))}
      </ImageList>

      {isViewerImageOpen && (
        <ImageViewer
          images={images}
          isViewerImageOpen={isViewerImageOpen}
          onClose={() => setViewerImage(false)}
        />
      )}
    </div>
  );
};

export default Gallery;
